document.addEventListener('alpine:init', () => {
  Alpine.data('collection', () => ({
    search: '',
    filters: {
      tags: '',
    },
    records: window.blogList || [],
    itemsPerPage: 9,
    currentPage: 0,
    num: 0,
    isOpen: false,
    currentIndex: 0,
    alpineReady: false,
    openModal(index) {
      this.currentIndex = index;
      this.isOpen = true;
      document.body.style.overflow = 'hidden'; // prevent scroll
    },
    closeModal() {
      this.isOpen = false;
      document.body.style.overflow = '';
    },
    prev() {
      if (this.currentIndex > 0) this.currentIndex--;
    },
    next() {
      if (this.currentIndex < this.page.length - 1) this.currentIndex++;
    },
    cleanDescription() {
      return this.blog_description.replace(/[^\w\s]/gi, ''); // Removes special characters
    },
    numOfPages() {
      const total = Math.ceil(this.filteredRecords.length / this.itemsPerPage);
      this.num = total - 1;
      return total;
    },
    handleSearch() {
      const query = this.$refs.searchInput.value.trim();
      this.search = query;
      this.currentPage = 0;

      const url = new URL(window.location.href);
      if (query) {
        url.searchParams.set('q', query);
      } else {
        url.searchParams.delete('q');
      }
      window.history.replaceState({}, '', url);
    },
    clearSearch() {
      this.search = '';
      if (this.$refs.searchInput) {
        this.$refs.searchInput.value = '';
      }

      const url = new URL(window.location.href);
      url.searchParams.delete('q');
      window.history.replaceState({}, '', url);

      this.currentPage = 0;
    },
    get page() {
      return this.filteredRecords.slice(
        this.currentPage * this.itemsPerPage,
        (this.currentPage + 1) * this.itemsPerPage
      );
    },
    async getRecords() {
      const allTags = this.records.flatMap((r) => r.blog_tags || []);
      this.tags = [...new Set(allTags)].sort();
      document.documentElement.classList.add('alpine');
    },
    get currentRecord() {
      return this.page?.[this.currentIndex] || null;
    },
    get filteredRecords() {
      let filtered = this.records;
      const selected = this.filters.tags;

      if (selected && selected !== 'all') {
        const selectedNormalized = selected.toLowerCase();
        filtered = filtered.filter((item) => item.blog_tags.some((tag) => tag.toLowerCase() === selectedNormalized));

        // Update URL param
        const url = new URL(window.location.href);
        url.searchParams.set('category', selected.replace(/\s+/g, '-').toLowerCase());
        window.history.replaceState({}, '', url);
      } else {
        const url = new URL(window.location.href);
        url.searchParams.delete('category');
        window.history.replaceState({}, '', url);
      }

      if (this.search !== '') {
        const q = this.search.toLowerCase();
        filtered = filtered.filter(
          (item) => item.blog_title.toLowerCase().includes(q) || item.blog_content?.toLowerCase().includes(q)
        );
      }

      return filtered;
    },

    message() {
      return `${this.filteredRecords.length} records`;
    },
    init() {
      this.getRecords();

      const params = new URLSearchParams(window.location.search);
      const categoryParam = params.get('category');
      if (categoryParam) {
        this.filters.tags = categoryParam.replace(/-/g, ' ');
      }
      const q = params.get('q');
      if (q) {
        this.search = q;
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.value = q;
          }
        });
      }

      this.$nextTick(() => {
        this.alpineReady = true;
      });

      this.$watch('filters', (filter) => (this.currentPage = 0));
    },
  }));
});
